module.exports = __webpack_public_path__ + "media/images/menu-0377a7c507e87a221dc00fbcdb73ed77.svg";